<ng-template #loading>
    <app-loading></app-loading>
</ng-template>

<div class="m-3">
    <input class="form-control" placeholder="Search all products..." [value]="searchValue"
        (input)="searchInput$.next($any($event.target).value || '')" />
</div>

@if (searchValue) {
<ng-container *ngIf="products$ | async as products; else loading">
    <div class="container my-5">
        @if (products.data.length == 0) {
        <div class="alert alert-info">No Products Found</div>
        }
        @else {
        @for(category of createProductList(products); track category.header) {
        <h2>{{category.header}}</h2>
        <div class="row justify-content-left g-4">
            @for(sub of category.subcategories; track sub.label){
            <h3>{{sub.label}}</h3>
            @for(product of sub.products; track product.id) {
            <div class="row g-3">
                <app-product-card [product]="product" [categoryName]="sub.label" [quoteId]="quoteId"></app-product-card>
            </div>
            }
            }
        </div>
        }
        }
    </div>
</ng-container>
}
@else {
<div class="container my-5">
    @for(category of productCategories; track category.name) {
    @if (!category.disabled) {
    <h2>{{category.name}}</h2>
    <div class="row justify-content-left g-4">

        @for(product of category.types; track product.id)
        {
        @if(!product.disabled && product.id)
        {
        <!-- Image Block -->
        <div class="col-6 col-sm-4 col-md-3 d-flex justify-content-center">
            <a [routerLink]="['/', 'product-search', product.id]" queryParamsHandling="preserve" class="image-link">
                <div class="image-block shadow">
                    <img src="{{product.image}}" alt="{{product.label}}" />
                    <div class="image-text-overlay">{{product.label}}</div>
                </div>
            </a>
        </div>
        }
        }
    </div>
    <br>
    }
    }
</div>

}